import { Action, Reducer } from "redux";
import { CategoryState, CategoryTypes, CategoryActionTypes } from "./categoryTypes";

export const INITIAL_STATE: CategoryState = {
	category: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const categoryReducer: Reducer<CategoryState> = (state: CategoryState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as CategoryActionTypes;
	switch (actionTypes.type) {
		case CategoryTypes.GET_CATEGORY:
			return {
				...state,
				category: { ...state.category, isLoading: true },
			};
		case CategoryTypes.SAVE_CATEGORY:
			return {
				...state,
				category: {
					...state.category,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CategoryTypes.RESET_REDUCER_CATEGORY:
			return {
				...state,
				category: INITIAL_STATE.category,
			};
		default:
			return state;
	}
};

export default categoryReducer;
